export default "__VITE_ASSET__C2J$5re3__"